import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import MainLayout from "./components/MainLayout";
import MyProfileLayout from "./components/My Profile/MyProfileLayout";
import Personalinfo from "./components/My Profile/PersonalInfo";
import DashBoard from "./components/DashBoard/DashBoard";
import PersonalGoals from "./components/My Profile/PersonalGoals";
import Security from "./components/My Profile/Security";
import Login from "./components/Auth/Login";
import Auth from "./components/Auth/Auth";
import VerifyEmail from "./components/Auth/VerifyEmail";
import ForgotPassword from "./components/Auth/ForgotPassword";
import ResetPassword from "./components/Auth/ResetPassword";
import OnBoarding from "./components/OnBoarding/OnBoarding";
import Plan from "./components/OnBoarding/Plan";
import OnBoardingLayout from "./components/OnBoarding/OnBoardingLayout";
import LandingPage from "./components/LandingPage/LandingPage";
import { RedirectRoute } from "./router/RedirectRoute";
import ProtectedRoute from "./router/ProtectedRoute";
import PrivacyPolicy from "./components/policy/PrivacyPolicy";
import Eula from "./components/policy/Eula";
import DeleteAccount from "./components/DeleteAccount/DeleteAccount";
import DeleteAccountVerification from "./components/DeleteAccount/DeleteAccountVerification";

const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/eula", element: <Eula /> },
  { path: "/delete-account", element: <DeleteAccount /> },
  { path: "/delete-account/:token", element: <DeleteAccountVerification /> },
  // {
  //   path: "/auth",
  //   element: (
  //     <RedirectRoute>
  //       <Auth />
  //     </RedirectRoute>
  //   ),
  //   children: [
  //     { index: true, element: <Navigate to="./login" replace /> },
  //     {
  //       path: "login",
  //       element: <Login />,
  //     },
  //     { path: "verify-email", element: <VerifyEmail /> },
  //     { path: "forgot-password", element: <ForgotPassword /> },
  //     { path: "reset-password/:id", element: <ResetPassword /> },
  //   ],
  // },
  // {
  //   path: "/app",
  //   element: (
  //     <ProtectedRoute>
  //       <MainLayout />
  //     </ProtectedRoute>
  //   ),
  //   children: [
  //     { index: true, element: <Navigate to="/app/dashboard" replace /> },
  //     { path: "dashboard", index: true, element: <DashBoard /> },
  //     {
  //       path: "my-profile",
  //       element: <MyProfileLayout />,
  //       children: [
  //         { index: true, element: <Navigate to="./personal-info" replace /> },
  //         { path: "personal-info", element: <Personalinfo /> },
  //         { path: "personal-goals", element: <PersonalGoals /> },
  //         { path: "security", element: <Security /> },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   path: "/on-boarding",
  //   element: <OnBoardingLayout></OnBoardingLayout>,
  //   children: [
  //     { index: true, element: <OnBoarding></OnBoarding> },
  //     { path: "plan", element: <Plan></Plan> },
  //   ],
  // },
  // { path: "/*", element: <Navigate to="/app/dashboard" replace /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
    <Toaster />
  </React.StrictMode>,
);
